import React from 'react';

import Container from '../Container';
import { Grid, Button, Typography } from '@gogame/components';
import { useStopJob } from 'scenes/TapjoyBidUpdate/data/mutations';
import Progress from './components/Progress';
import { useStatusCompactDetails } from 'scenes/TapjoyBidUpdate/hooks/useStatusCompactDetails';

const ProcessingFile = ({ data }) => {
  const [stopJob] = useStopJob();
  const getStatusCompactDetails = useStatusCompactDetails();

  const handleStop = async () => {
    await stopJob();
  };
  return (
    <Container>
      <Grid
        container
        spacing={1}
        direction={'column'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Grid item>
          <Progress value={data.percentsCompleted} />
        </Grid>
        <Grid item>
          <Typography variant={'caption'}>
            {getStatusCompactDetails('Update started', data)}
          </Typography>
        </Grid>
        <Grid item>
          <Button variant={'outlined'} onClick={handleStop}>
            Stop bid update
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProcessingFile;
